var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYidongduan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "16px",
    height: "16.00px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0m228.968944 0l566.062112 0q228.968944 0 228.968944 228.968944l0 566.062112q0 228.968944-228.968944 228.968944l-566.062112 0q-228.968944 0-228.968944-228.968944l0-566.062112q0-228.968944 228.968944-228.968944Z",
    fill: "#FFC101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M309.108075 226.424845m38.16149 0l329.46087 0q38.161491 0 38.16149 38.16149l0 493.55528q0 38.161491-38.16149 38.161491l-329.46087 0q-38.161491 0-38.16149-38.161491l0-493.55528q0-38.161491 38.16149-38.16149Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M351.085714 273.490683m15.264597 0l291.299378 0q15.264596 0 15.264597 15.264597l0 361.262111q0 15.264596-15.264597 15.264597l-291.299378 0q-15.264596 0-15.264597-15.264597l0-361.262111q0-15.264596 15.264597-15.264597Z",
    fill: "#FFC101",
    opacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M512.636025 730.156522m-35.617391 0a35.617391 35.617391 0 1 0 71.234782 0 35.617391 35.617391 0 1 0-71.234782 0Z",
    fill: "#FFC101"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYidongduan);
export default __webpack_public_path__ + "static/media/yidongduan.d6c5c948d25d3cd68a5b9842ad0674e7.svg";
export { ForwardRef as ReactComponent };